import React from 'react';
import PropTypes from 'prop-types';

import Cards from '../../../../../components/organisms/cards/template-one';

// Test included with archive & cards test
const Items = ({ module, page }) => <Cards module={module} page={page} />;

Items.propTypes = {
  module: PropTypes.shape({
    module_title: PropTypes.string,
  }).isRequired,
  page: PropTypes.shape({}),
};

export default Items;
